export const getToolsState = (state) => state.tools;
export const getIsToolsActive = (state) => state.tools.isToolsActive;
